import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "mb-15 mb-md-30 d-sm-flex align-items-center justify-content-between" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h6", { class: "card-title fw-bold mb-0" }, "LISTE DES DERNIERES VENTES", -1)
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, " # "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Date "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Client "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Montant "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Montant sans Epargne ")
  ])
], -1)
const _hoisted_8 = { class: "shadow-none lh-8 fw-bold ps-0" }
const _hoisted_9 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-body-tertiary" }
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium text-body-tertiary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_router_link, {
          to: "/Reglements",
          class: "default-btn text-white fw-medium d-inline-block text-decoration-none transition ps-10 pe-10 pt-5 pb-5"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Voir la liste ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orders, (order) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: order.id
              }, [
                _createElementVNode("th", _hoisted_8, [
                  _createVNode(_component_router_link, {
                    to: "/product-details",
                    class: "text-decoration-none text-black-emphasis"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(order.id), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.format_Date(order.dateVente)), 1),
                _createElementVNode("td", _hoisted_10, _toDisplayString('[ '+order.client.code+' ] '+order.client.prenoms+ ' ' + order.client.nom), 1),
                _createElementVNode("td", _hoisted_11, _toDisplayString(order.montant), 1),
                _createElementVNode("td", _hoisted_12, _toDisplayString((order.montant)? order.montantSansEpargne : '-'), 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}